import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { catchError, forkJoin, map, Observable, of, startWith, Subject, takeUntil } from 'rxjs';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { UserSessionService } from '../../services/user.service';
import { MatOption, MatSelectModule } from '@angular/material/select';
import { UserEnseigneService } from '../../services/userEnseigne.service';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatButtonModule, MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-filiale-selector',
  standalone: true,
  templateUrl: './filiale-selector.component.html',
  styleUrl: './filiale-selector.component.scss',
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormField,
    FormsModule,
    MatLabel,
    MatOption,
    MatIconButton,
    MatIcon,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class FilialeSelectorComponent implements OnInit, OnDestroy {
  selectedFiliale:string="";
  filialeCtrl = new FormControl('');
  filiales: string[] = [];
  filteredFiliales$!: Observable<string[]>;
  private readonly _destroying$: Subject<void> = new Subject();
  activiteAdherent!:string;

  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger!: MatAutocompleteTrigger;

  constructor(
    private readonly userSessionService: UserSessionService,
    private readonly userEnseigneService: UserEnseigneService,
  ) {}
  ngOnDestroy(): void {
        this._destroying$.next();
    this._destroying$.complete();
  }

ngOnInit(): void {

  const currentUser = JSON.parse(
    localStorage.getItem('currentUserCockpit') || '{}'
  );
this.activiteAdherent = this.userSessionService.getActivite();
  if (!currentUser?.email) {
    this.filiales = [];
    return;
  }

  const email = currentUser.email;

  // ON ÉCOUTE LES RÔLES DEPUIS LE SERVICE
  this.userSessionService.gpoRole$
    .pipe(takeUntil(this._destroying$))
    .subscribe(gpoRole => {

      const calls: any[] = [];

      // RESPONSABLE → User_Enseigne
      if (gpoRole.isResponsable) {
        calls.push(
          this.userEnseigneService
            .fetchEnseignesByEmail(email)
            .pipe(catchError(() => of([])))
        );
      }

      // TITULAIRE / ADHERENT → Officines → Filiales
      if (gpoRole.isTitulaire || gpoRole.isAdherent) {
        calls.push(
          this.userSessionService
            .getOfficine(email, 'FilialeSelector')
            .pipe(
              map(adherents =>
                adherents
                  ?.map(a => a.filiale)
                  .filter(f => !!f) ?? []
              ),
              catchError(() => of([]))
            )
        );
      }

      if (calls.length === 0) {
        this.filiales = [];
        return;
      }

      // Fusion des filiales (multi-rôles)
      forkJoin(calls)
        .pipe(takeUntil(this._destroying$))
        .subscribe(results => {

          this.filiales = [...new Set(results.flat())];

          // Auto-sélection si une seule filiale
           if (this.filiales.length > 0) {
            this.selectedFiliale = this.filiales[0];
            this.filialeCtrl.setValue(this.selectedFiliale);
            this.userSessionService.setFiliale(this.selectedFiliale);
           }

        });
    });

  // Autocomplete → affiche TOUTES les filiales
  this.filteredFiliales$ = this.filialeCtrl.valueChanges.pipe(
    startWith(''),
    map(value => (value ?? '').toString().toLowerCase()),
    map(value =>
      this.filiales.filter(f =>
        f.toLowerCase().includes(value)
      )
    )
  );
}



  getAllowedFiliales(): string[] {

  const currentUser = JSON.parse(
    localStorage.getItem('currentUserCockpit') || '{}'
  );

  if (!currentUser) return [];

  const roles: string[] = currentUser.roles ?? [];

  let filiales: string[] = [];

  //  RESPONSABLE → User_Enseigne
  if (roles.includes('pfa-gpo.responsable')) {

    const enseignes =
      currentUser.User_Enseigne?.map((e: any) => e.filiale) ?? [];

    filiales.push(...enseignes);
  }

  // TITULAIRE / ADHERENT → User_Adherent → Officines
  if (
    roles.includes('pfa-gpo.titulaire') ||
    roles.includes('pfa-gpo.adherent')
  ) {

    const officines =
      currentUser.User_Adherent?.officines ?? [];

    const filialesFromOfficines =
      officines.map((o: any) => o.filiale);

    filiales.push(...filialesFromOfficines);
  }

  // Suppression des doublons
  filiales = [...new Set(filiales)];

  return filiales;
}


  onFilialeSelected(filiale: string) {
    this.userSessionService.setFiliale(filiale || null);
  }

  onClearFiliale() {
    this.filialeCtrl.setValue('');
    this.userSessionService.setFiliale(null);
  }

  onInputFocus(): void {
    this.autocompleteTrigger.openPanel();
  }
}
